<template>
    <section class="autorization__container">
        <div class="content">
            <div class="left">
                <slot name="left"></slot>
            </div>
            <div class="right">
                <slot name="right"></slot>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style scoped>
.autorization__container {
    height: calc(100vh - 66px);
}

.content {
    display: flex;
    height: 100%;
}

.content .left {
    width: 40%;
    height: 100%;
    background-size: cover;
    background-position: center;
        background-image: url('@/assets/img/banner_1.jpg');
    background-size: cover;
    background-position: center;
}

.content .right {
    width: 60%;
}
@media (max-width: 1024px) {
    .content .left {
        display: none;
    }
    .content .right {
        width: 100%;
    }
}
</style>
